import React from "react";
import ReactDOM from "react-dom/client";
import { App as AntdApp, ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import App from "./App";
import CustomerChatTest from "./pages/CustomerChatTest";
import "./styles.css";
import "./antd-react-render";
import { redirectLocalHttps } from "./local-https-entry";

if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}

void redirectLocalHttps(window.location).then(redirected => {
if (redirected) return;
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN} theme={{ token: { colorPrimary: "#0f766e", borderRadius: 12, fontFamily: "Inter, PingFang SC, Microsoft YaHei, sans-serif" } }}>
      <AntdApp>{window.location.pathname.replace(/\/$/, "") === "/customer-chat-test" ? <CustomerChatTest /> : <App />}</AntdApp>
    </ConfigProvider>
  </React.StrictMode>
);
});
